@if (detailed) {
    <div class="selected-icon-area" (click)="clicked()">
        <div class="selected-icon">
            <ng-container [ngTemplateOutlet]="iconTemplate"> </ng-container>
        </div>
        <input
            class="form-control form-control-sm icon-name"
            value="{{ iconName | titlecase }} ({{ selector }})"
            disabled
            type="text"
            inputTooltip
        />
    </div>
} @else {
    <ng-container [ngTemplateOutlet]="iconTemplate"> </ng-container>
}

<ng-template #iconTemplate>
    <i
        class="{{ selector }} {{ appendClass }}"
        [class.fa-spin]="animated"
        [class.fa-border]="bordered"
        [style.color]="color | safe: 'style'"
    ></i>
</ng-template>
